module.exports = __webpack_public_path__ + "img/horizontal_4_5_8004.9f8c0340.png";